@if(faqWidgetService.isOpen()) {
  <app-faq-window
    [items]="rootItems()"
    (closed)="onClose()"
  ></app-faq-window>
}
